import { createTypes } from './createTypes';

export default createTypes('LOGIN');
